<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row align-items-center mb-1">
                <div class="col-md-6">
                    <div class="h2">Edit Teaser Template</div>
                </div>
                <div class="col-md-2 offset-md-4 text-right center">
                    <router-link to="/admin/teasertemplate/list" class="btn btn-primary" role="button">
                        back
                    </router-link>
                </div>
            </div>
          <form @submit.prevent="update" v-if="templatePayload">
            <div class="row justify-content-md-center">
              <div class="col-12">
                <div class="row">
                  <div class="col-md-6">
                    <fg-input type="text"
                              v-model="templatePayload.eid"
                              label="RecordId"
                              placeholder="RecordId"
                              readonly
                            >
                    </fg-input>
                  </div>
                  <div class="col-md-6">
                    <fg-input type="text"
                              v-model="contentTypeText"
                              label="Content Type"
                              placeholder="Content Type"
                              readonly
                    >
                    </fg-input>
                  </div>
                  <div class="col-md-12">
                    <fg-text-area
                      rows="2"
                      v-model="templatePayload.messageText"
                      label="Message"
                      placeholder="Enter Value"
                      v-validate="rules.messageText"
                      data-vv-name="Message"
                      cus-name="Message"
                      :has-errors="errors"
                      :is-fields="fields">
                    </fg-text-area>
                  </div>


                  <div class="col-3" v-if="status.length && templatePayload.contentType === 1">
                    <fg-select
                      v-model="templatePayload.active"
                      label="Status"
                      v-validate="rules.active"
                      data-vv-name="active"
                      cus-name="active"
                      :has-errors="errors"
                      :is-fields="fields"
                      :list="status"
                      selectedKey="id">
                    </fg-select>
                  </div>

                </div>
              </div>





              <div class="col-6 text-center">
                <button type="submit" :disabled="errors.any()" class="btn btn-primary btn-fill btn-block">
                  Update Template
                </button>
              </div>
            </div>
            <div class="clearfix"></div>
          </form>
        </div>
    </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  export default {
    name: 'EditTeaserTemplate',
    created (){
      this.eid = this.$route.params.id
      this.contentType = this.$route.params.contentType
      this.fetchTemplateDetails(this.contentType, this.eid)
    },
    data () {
      return {
        userId: 0,
        corporationId: 0,
        templatePayload: {
          messageText: '',
          eid: 0,
          contentType: 0,
          active: 1
        },
        eid : 0,
        contentType: 0,
        contentTypeText: '',
        corps: [],
//            playlist: null,
        status: [{name:'Select Status'}, {id:1, name:'Active'}, {id:0, name:'Inactive'}],
        rules: {
          messageText : {required: true},
          active: {required: true}
        }
      }
    },
    methods: {
      fetchTemplateDetails (contentType, id) {
        let self = this
        this.$store.dispatch('FETCH_TEASER_TEMPLATE', contentType)
          .then((res) => {
            let filterId = res.filter (x => {
              return x.eid.toString() === id.toString()
            });
            self.templatePayload.messageText = filterId[0].messageText
            self.templatePayload.eid = filterId[0].eid
            self.templatePayload.contentType = filterId[0].contentType
            self.contentTypeText = filterId[0].contentType === 1 ? 'Email Subject': 'Email Body'
            self.templatePayload.active = filterId[0].active
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
      update () {
          let updateUserCorporation = () => {
            this.$store.dispatch('UPDATE_EMAIL_TEMPLATE', this.templatePayload)
              .then((res) => {
                console.log("UPDATE_Template res : ", res);
                this.showPopup('Success!', 'Email Template is successfully updated', 'success', () => this.$router.push('/admin/teasertemplate/list'))
              })
              .catch(err => {
                this.showPopup('Error!', 'some thing happen wrong', 'error')
                console.log("UPDATE_Template API error : ", err);
              })
          };
          updateUserCorporation();
      },
      showPopup(title, msg, popupType, cb){
        this.$swal( title, msg, popupType
        ).then(res => {
          cb && cb();
          return res
        })
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      fetchUserReference (userId) {
        this.$store.dispatch('FETCH_SUBSCRIBERS_FREETRIAL')
          .then((res) => {
            let resultSet = res.payload;
            let filteredList = resultSet.filter( x => {
              return x.userId === userId
            })
            this.userRef = filteredList[0];
          })
          .catch(err => {
            console.log("API error : ", err);
          })
      },
    },
    computed: {
      ...mapGetters([ 'corporations', 'selectedPlaylist']),
      routeName () {
        const {name} = this.$route;
        return this.capitalizeFirstLetter(name);
      }
    }
  }
</script>

<style>
  .form-control{
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Teaser/TeaserTemplateEdit.vue